
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M18.864 5.38603C18.864 5.10989 18.6401 4.88603 18.364 4.88603L13.864 4.88603C13.5878 4.88603 13.364 5.10989 13.364 5.38603C13.364 5.66217 13.5878 5.88603 13.864 5.88603L17.864 5.88603L17.864 9.88603C17.864 10.1622 18.0878 10.386 18.364 10.386C18.6401 10.386 18.864 10.1622 18.864 9.88603L18.864 5.38603ZM5.9896 18.4675L6.626 17.8311L5.91889 17.124L5.28249 17.7604L5.9896 18.4675ZM7.89879 16.5583L9.17158 15.2855L8.46447 14.5784L7.19168 15.8512L7.89879 16.5583ZM10.4444 14.0127L11.7172 12.7399L11.0101 12.0328L9.73727 13.3056L10.4444 14.0127ZM12.99 11.4671L14.2628 10.1944L13.5556 9.48725L12.2829 10.76L12.99 11.4671ZM15.5355 8.92156L16.8083 7.64877L16.1012 6.94166L14.8284 8.21446L15.5355 8.92156ZM18.0811 6.37598L18.7175 5.73958L18.0104 5.03248L17.374 5.66887L18.0811 6.37598Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiTextLeftOblique",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
